import CookieConsent from "react-cookie-consent";
import { Link } from "react-router-dom";
import useWindowDimensions from "../../../../mainApp/features/Hooks/useWindowDimensions.js";

function CookieBar() {
  const { width } = useWindowDimensions();
  const isMobile = width <= 768;

  const containerStyle = {
    backgroundColor: "#202123",
    color: "white",
    padding: "34px",
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "20px",
    fontFamily: "'Poppins', sans-serif",
  };

  const mobileContainerStyle = {
    flexDirection: "column",
    textAlign: "center",
    padding: "14px",
  };

  const contentStyle = {
    margin: "0",
    flex: "1 1 auto",
    maxWidth: "800px",
  };

  const buttonStyle = {
    backgroundColor: "#ECECEC",
    color: "#101010",
    fontSize: "14px",
    fontWeight: "500",
    borderRadius: "24px",
    border: "none",
    padding: "12px 24px",
    cursor: "pointer",
    flexShrink: 0,
    fontFamily: "'Poppins', sans-serif",
  };
  
  const mobileButtonStyle = {
    width: "100%",
    maxWidth: "320px",
  };

  return (
    <>
      <CookieConsent
        disableButtonStyles={true}
        disableStyles={true}
        location="bottom"
        buttonText="Akceptuj"
        cookieName="myAwesomeCookieName2"
        style={isMobile ? { ...containerStyle, ...mobileContainerStyle } : containerStyle}
        contentStyle={contentStyle}
        buttonStyle={isMobile ? { ...buttonStyle, ...mobileButtonStyle } : buttonStyle}
        expires={150}
      >
        Strona wykorzystuje niezbędne pliki cookies w celu jej prawidłowego
        funkcjonowania. Kliknięcie przycisku "Akceptuj" oznacza zgodę na ich
        wykorzystywanie. Dowiedz się więcej w{" "}
        <Link
          to="/policy"
          style={{ textDecoration: "underline", color: "inherit" }}
        >
          polityce prywatności
        </Link>
        .
      </CookieConsent>
    </>
  );
}

export default CookieBar;